import { getVar } from "config";

export const getDashboardUrl = (token: string, eventId: string) =>
  `${getVar(
    "REACT_APP_ANALYTICS_DASHBOARD_URL",
  )}?userToken=${token}&eventid=${eventId}`;
